module.exports = __webpack_public_path__ + "img/op_img-header.cf3a1a7.png";